import { taskManagerApiPaths } from '@/hooks/api/_paths'
import { useApiRequest } from '@/lib/http-utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export function useDeleteServiceRegistryMutation({ serviceId }: { serviceId: string }) {
  const { apiRequest, domainId } = useApiRequest()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['delete-service-registry', serviceId],
    mutationFn: async () => {
      const path = taskManagerApiPaths.mcpDelete({ domainId, serviceId })

      const response = await apiRequest({
        path,
        options: { method: 'DELETE' },
      })

      if (!response.ok) {
        throw new Error('FAILED_TO_DELETE_AGENT')
      }

      return true
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['service-registry', domainId] })
    },
  })
}
